import Slots from './Slots'
function Map() {
    // const mystyle = {
    //     width: "50px",
    //     height: "50px",
    //     borderRadius: "20px",
    //     backgroundColor: "green",
    //     display: "inline-block",
    //     margin:"2px",
    //   };
    return (
        <div style={{ minWidth: "18rem" }}>
            <div>
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
            </div>
            <div>
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
            </div>
            <div>
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
                <Slots />
            </div>

        </div>

    );
}

export default Map;
